import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const BASE = `${config.BASE_URL}/tournament-payments`;


async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

function assertOk(res, data, fallbackMessage) {
  if (!res.ok) throw new Error(data.message || fallbackMessage);
}

export const fetchAccountantTournamentPayments = async (query = {}) => {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([k, v]) => {
    if (v !== undefined && v !== null && String(v).trim() !== "") {
      params.set(k, String(v));
    }
  });
  const qs = params.toString();
  const url = qs ? `${BASE}/?${qs}` : `${BASE}/`;
  const res = await authFetch(url, { credentials: "include", headers: buildAuthHeaders() });
  const data = await parseJson(res);
  assertOk(res, data, "Failed to load tournament payments");
  return data;
};

export const verifyAccountantTournamentPayment = async (paymentId, csrfToken, paymentVerified = true) => {
  const res = await authFetch(`${BASE}/verify-payment`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    body: JSON.stringify({ payment_id: paymentId, payment_verified: paymentVerified }),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Could not update payment verification");
  return data;
};

export const verifyAccountantTournamentPaymentsBulk = async (paymentIds, csrfToken, paymentVerified = true) => {
  const res = await authFetch(`${BASE}/verify-payments-bulk`, {
    method: "POST",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
    body: JSON.stringify({ payment_ids: paymentIds, payment_verified: paymentVerified }),
  });
  const data = await parseJson(res);
  assertOk(res, data, "Bulk verification failed");
  return data;
};
